import apiAxios from "../../apiAxios";

export default async function setParticipantWelcomed(): Promise<void> {
  await apiAxios.post("/participants/welcomed");
}
